import get from 'lodash/get';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';
import {
  removeArrayItem,
  updateArrayItem,
  updateOrPush,
} from '../../utils/arrayModify';

export const consts = createReqConsts('circles', 'myFamilyCircle', [
  'REMOVE_ITEM',
  'REMOVE_CAREGIVER_ROLE',
  'ADD_INVITATION',
  'REMOVE_INVITATION',
  'ADD_CAREGIVER_INVITATION',
  'REMOVE_CAREGIVER_INVITATION',
]);

export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'family_circle',
  type: 'get',
});

const requestReducer = createReqReducer(consts);

const removeCaregiverRole = (state, { id }) => {
  const list = get(state, 'familyMembers', []).map(item => {
    if (item.id === id) {
      return { ...item, caregiver: false };
    }
    return item;
  });

  return { ...state, familyMembers: [...list] };
};

const removeFromCircle = (state, { id }) => {
  const familyMembers = removeArrayItem(
    get(state, 'familyMembers', []),
    'id',
    id,
  );

  return { ...state, familyMembers };
};

const addInvitation = (state, { login, role, invitationId, user }) => {
  const pending = get(state, 'pendingInvitations', []);
  const pendingInvitations = updateOrPush(
    pending,
    { login },
    { login, role, invitationId, user },
  );

  return { ...state, pendingInvitations };
};

const removeInvitation = (state, { invitationId }) => {
  const pendingInvitations = removeArrayItem(
    get(state, 'pendingInvitations', []),
    'invitationId',
    invitationId,
  );

  return { ...state, pendingInvitations };
};

const addCaregiverInvitation = (state, { userId, invitationId }) => {
  const prevFamilyMembers = get(state, 'familyMembers', []);

  const updateValues = {
    pendingCaregiver: true,
    invitationId,
    userId,
  };

  const familyMembers = updateArrayItem(
    prevFamilyMembers,
    { id: userId },
    updateValues,
  );
  const pendingCaregivers = get(state, 'pendingCaregivers', []);
  pendingCaregivers.push({ userId, invitationId });

  return { ...state, pendingCaregivers, familyMembers };
};

const removeCaregiverInvitation = (state, { invitationId }) => {
  const updateValues = {
    pendingCaregiver: false,
    invitationId: undefined,
  };

  const prevPending = get(state, 'pendingCaregivers', []);
  const prevFamilyMembers = get(state, 'familyMembers', []);

  const pendingCaregivers = removeArrayItem(
    prevPending,
    'invitationId',
    invitationId,
  );
  const familyMembers = updateArrayItem(
    prevFamilyMembers,
    { invitationId },
    updateValues,
  );

  return { ...state, pendingCaregivers, familyMembers };
};

export default (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case consts.REMOVE_ITEM:
      return removeFromCircle(state, payload);
    case consts.REMOVE_CAREGIVER_ROLE:
      return removeCaregiverRole(state, payload);
    case consts.ADD_INVITATION:
      return addInvitation(state, payload);
    case consts.REMOVE_INVITATION:
      return removeInvitation(state, payload);
    case consts.ADD_CAREGIVER_INVITATION:
      return addCaregiverInvitation(state, payload);
    case consts.REMOVE_CAREGIVER_INVITATION:
      return removeCaregiverInvitation(state, payload);

    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/circles/myFamilyCircle.js